import { useMemo, type PropsWithChildren } from 'react'
import { BrandCard } from '../BrandCard/BrandCard';
import { BrandArticleInlineContent } from './BrandArticleInlineContent';
import clsx from 'clsx';
import { cn } from '../../utils/cn';

type BrandArticleInlineProps = PropsWithChildren<{
  className?: string;
}>;

export const BrandArticleInline = ( { className, children }: BrandArticleInlineProps ) => {

  const Components = useMemo( () => {
    return Array.isArray( children ) ? children : [ children ]
  }, [ children ] );
  const Brand = Components.find( c => c?.type?.displayName === BrandCard.displayName );
  const Content = Components.find( c => c?.type?.displayName === BrandArticleInlineContent.displayName );

  return (
    <div className={ cn( clsx( 'grid md:flex-row gap-5 md:gap-10',
      {
        'grid grid-cols-1': Brand == null,
        'md:grid-cols-[max-content_1fr]': Brand != null
      } ), className ) }>
      { Brand && (
        <div className={ 'flex items-center md:items-start w-full md:w-fit [&_div]:max-w-[176px] md:[&_div]:max-w-[128px]' }>
          { Brand }
        </div>
      )}
      { Content }
    </div>
  )
}
BrandArticleInline.displayName = 'BrandArticleInline';
